import cx from "classnames";
import { FC, PropsWithChildren } from "react";
import { testIds } from "../../constants/testIds.constants";
import LoadingComponent from "../LoadingComponent";

export interface ITransactionSubmitting {
  className?: string;
}

const TransactionSubmitting: FC<PropsWithChildren<ITransactionSubmitting>> = ({
  children,
  className,
}) => {
  return (
    <div className={cx("my-auto", className)}>
      <div
        className="relative flex w-full flex-col items-center justify-center gap-4 motion-safe:animate-pulse xl:gap-8"
        data-testid={testIds.exchangeFlow.transactionSubmitting.container}
      >
        <LoadingComponent size="medium" />

        <div className="flex w-full flex-col items-center justify-center gap-4 text-center xl:gap-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default TransactionSubmitting;
